import domReady from '@wordpress/dom-ready';
import { CountUp } from 'countup.js';
import { _x } from '@wordpress/i18n';

domReady(() => {
  const statNumbers = document.querySelectorAll('.key-stat__number');

  if (0 < statNumbers.length) {
    statNumbers.forEach((statNumber) => {
      const number = parseFloat(statNumber.getAttribute('data-number'));
      const decimals =
        parseInt(statNumber.getAttribute('data-decimals'), 10) || 0;

      const animation = new CountUp(statNumber, number, {
        duration: 2,
        decimalPlaces: decimals,
        separator: _x(',', 'number thousand separator', 'vtx'),
        decimal: _x('.', 'decimal separator', 'vtx'),
        enableScrollSpy: true,
        scrollSpyDelay: 0,
        scrollSpyOnce: true,
      });

      animation.handleScroll();
    });
  }
});
